// extracted by mini-css-extract-plugin
export default {"steps":"Au-z","header":"Bu-z","description":"Cu-z"};